import { useTranslation } from 'react-i18next';
import { FaPhone, FaMapPin, FaEnvelope } from 'react-icons/fa';

import contactImg from '@/assets/contact_illustration.svg';

const sections = [
  { title: 'languagesSupportTitle', content: 'languagesSupport' },
  { title: 'replyAssuranceTitle', content: 'replyAssurance' },
  { title: 'servicesReminderTitle', content: 'servicesReminder' },
  { title: 'agileTeamTitle', content: 'agileTeam' },
  { title: 'noTechnicalSkillsTitle', content: 'noTechnicalSkills' },
  { title: 'teamTakeoverTitle', content: 'teamTakeover' },
];

export const Contact = () => {
  const { t } = useTranslation('contact');

  return (
    <>
      <div className="section">
        <h1 className="section-title flex justify-self-center">{t('title')}</h1>

        <div className="flex justify-center mt-16">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:w-4/6">
            <div className="col-span-2">
              <div className="section-content">{t('subtitle')}</div>
            </div>
            <div className="flex justify-center items-center">
              <img
                src={contactImg}
                alt={t('title')}
                className="h-[50v] object-cover"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>

      <div className="section bg-dark text-white rounded-lg">
        <div className="flex justify-center">
          <div className="md:w-4/6">
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 my-10 xx-10 w-full">
              <div className="flex justify-center bg-backgroundItems/20 rounded-xl py-5">
                <div className="flex flex-col items-center gap-5">
                  <div className="flex justify-center items-center bg-button rounded-full h-20 w-20">
                    <FaPhone className="text-white w-8 h-8" />
                  </div>
                  <div className="font-semibold">
                    <a href="tel:+48500570440" className="pl-2 py-3 text-lg hover:text-button">
                      +48 500 570 440
                    </a>
                  </div>
                </div>
              </div>

              <div className="flex justify-center bg-backgroundItems/20 rounded-xl py-5">
                <div className="flex flex-col items-center gap-5">
                  <div className="flex justify-center items-center bg-button rounded-full h-20 w-20">
                    <FaMapPin className="text-white w-8 h-8" />
                  </div>
                  <div className="font-semibold">
                    <a
                      href="https://maps.app.goo.gl/7i6ZPQZL2s4V7dg16"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="pl-2 py-3 text-lg hover:text-button"
                    >
                      ul. Technologiczna 2, 45-839 Opole
                    </a>
                  </div>
                </div>
              </div>

              <div className="flex justify-center bg-backgroundItems/20 rounded-xl py-5">
                <div className="flex flex-col items-center gap-5">
                  <div className="flex justify-center items-center bg-button rounded-full h-20 w-20">
                    <FaEnvelope className="text-white w-8 h-8" />
                  </div>
                  <div className="font-semibold">
                    <a
                      href="mailto:contact@intechnity.com"
                      className="pl-2 py-3 text-lg hover:text-button"
                    >
                      contact@intechnity.com
                    </a>
                  </div>
                </div>
              </div>
            </div>

            <ul className="space-y-4 mt-24">
              {sections.map((section, index) => (
                <div
                  key={'section' + index}
                  className="border rounded-lg border-white p-8 text-lg md:text-xl font-semibold"
                >
                  {t(section.content)}
                </div>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </>
  );
};
